export class UtilityProcesseModel {
  GetDropdownlists: any;
  GetUtilityProcessMasterdata: any;
  GetUtilityProcessPublisherMappingdata: any;
  ShowUtilityProcessMasterAPI: any;
  UpdateUtilityProcessMasterAPI: any;
  ShowUtilityProcessPubMasterAPI: string;
  UpdateUtilityProcessPubMappingAPI: any;
  deleteUtilityProcessMasterAPI: string;
  DeleteUtilityProcessPublisherMappingAPI: string;
  DeleteUtilityProcessPublisherMappingTransAPI: string;


}
